/** @jsxImportSource theme-ui */
import { Box, useThemeUI } from "theme-ui";
import { useSelector } from "react-redux";
import { selectUIVersion } from "store/app";
import { motion } from "framer-motion";

import { Customisations, FooterSelector, Tabs } from "components";
import * as styles from "./Product.styles";

export default function CustomisationsContainer({
  customisations,
  selectedCustomisationId,
  userChoiceValues,
  dispatchSetCustomisationId,
  dispatchDisplayReviewModal,
}) {
  const UIVersion = useSelector(selectUIVersion);

  const {
    theme: { isDesktop },
  } = useThemeUI();

  return (
    <motion.div
      sx={styles.customisationsContainer}
      initial={{
        y: "100%",
        opacity: 0,
      }}
      animate={{
        y: "0%",
        opacity: 1,
        transition: {
          duration: 0.3,
        },
      }}
    >
      <Box sx={styles.tabsContainer}>
        <Tabs
          tabs={customisations}
          selectedTabId={selectedCustomisationId}
          userChoiceValues={userChoiceValues}
          selectTab={dispatchSetCustomisationId}
          UIVersion={UIVersion}
        />
      </Box>

      <Customisations
        key={selectedCustomisationId}
        customisations={customisations}
        selectedCustomisationId={selectedCustomisationId}
        UIVersion={UIVersion}
      />

      {isDesktop && (
        <FooterSelector displayReviewModal={dispatchDisplayReviewModal} />
      )}
    </motion.div>
  );
}
